import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { PorFormularioComponent } from './por-formulario.component';

@Injectable()
export class PorFormularioGuard implements CanDeactivate<PorFormularioComponent> {

    canDeactivate(component: PorFormularioComponent): boolean {
        if (component.nuevaActividad && component.idActivityNew) {
            const salir = confirm('Tiene una actividad en creación sin guardar. Si sale, se eliminará. ¿Desea continuar?');
            if (salir) {
                component.cancelarCreacion(component.idActivityNew);
            }
            return salir;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/actividades/por-formulario/por-formulario.guard.ts